import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const NotifyMe = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon width="25" height="24" viewBox="0 0 25 24" {...rest}>
      <path
        d="M12.4994 9.35303L12.5005 13.3547"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4991 11.3544L14.5008 11.3533"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0089 18.0024V18.5147C10.0089 19.8893 11.1233 21.0037 12.4979 21.0037H12.4999C13.1603 21.004 13.7938 20.7419 14.261 20.2751C14.7281 19.8083 14.9907 19.1751 14.991 18.5147V18.0024"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4495 18.0025C19.5838 18.0025 20.5034 17.0829 20.5034 15.9486V15.9486C20.5029 15.3724 20.2741 14.8198 19.8671 14.412L18.5025 13.0484V8.99872C18.5025 5.68363 15.8151 2.99622 12.5 2.99622V2.99622C9.18495 2.99622 6.49754 5.68363 6.49754 8.99872V13.0484L5.13297 14.412C4.72596 14.8198 4.49717 15.3724 4.4967 15.9486V15.9486C4.4967 16.4933 4.71309 17.0157 5.09826 17.4009C5.48344 17.7861 6.00584 18.0025 6.55056 18.0025H18.4495Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

NotifyMe.propTypes = {
  color: PropTypes.string
};

NotifyMe.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default NotifyMe;
